import { FileUploadProps } from './FileUpload.props';
import { VisuallyHiddenInput } from './FileUpload.styles';

export const FileUpload = ({
  inputRef,
  handleFileUpload,
  acceptedFileTypes,
}: FileUploadProps) => (
  <VisuallyHiddenInput
    type="file"
    ref={inputRef}
    accept={acceptedFileTypes}
    onChange={(event) => {
      const file = event.target.files ? event.target.files[0] : null;
      if (file) {
        handleFileUpload(file);
      }
      if (inputRef?.current) {
        inputRef.current.value = '';
      }
    }}
  />
);
